import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABar, CTAButtonOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { CheckCircleIcon, ArrowRightIcon, UsersIcon, WrenchIcon, LeafIcon, ClockIcon, DollarSignIcon, ThumbsUpIcon, HomeIcon, TrendingUpIcon, ShieldCheckIcon, SparklesIcon, SearchIcon, SproutIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Backyard Cleaning',
  slug: 'backyard-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
}, {
  name: 'Commercial Cleaning',
  slug: 'commercial-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
}, {
  name: 'Driveway Cleaning',
  slug: 'driveway-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
}, {
  name: 'Solar Panel Cleaning',
  slug: 'solar-panel-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
}, {
  name: 'Trash Can Cleaning',
  slug: 'trash-can-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
export function PaverCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-1530">
      <Navbar data-id="element-1531" />
      <main data-id="element-1532">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Paver Cleaning" subheadline="Our Paver Cleaning services restore the look of your outdoor spaces by removing dirt, stains, and weeds with eco-friendly power washing, ensuring your pavers stay beautiful and durable for years." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Get Started',
        href: '#contact'
      }} data-id="element-1533" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1534">
          <div className="max-w-7xl mx-auto" data-id="element-1535">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-1536">
              <div className="w-full lg:w-1/2" data-id="element-1537">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-1538">
                  <img src="https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp" alt="Paver Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-1539" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-1540">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-1541">
                  Paver Cleaning
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-1542">
                  Our Paver Cleaning services offer eco-friendly, deep cleaning
                  to remove stains, moss, and dirt, enhancing the look and
                  durability of your pavers. Using advanced techniques, we leave
                  your outdoor spaces looking revitalized and well-maintained.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1543" />

        {/* Section — Revitalize Your Outdoor Spaces */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1544">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1545">
            <h2 className="font-bold mb-8" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1546">
              Paver Cleaning Services: Revitalize Your Outdoor Spaces
            </h2>
            <p className="mb-4" style={bodyStyle} data-id="element-1547">
              Pavers are a beautiful and durable option for driveways, patios,
              walkways, and pool decks, but over time, they can become dirty,
              discolored, and overgrown with weeds or moss. Our professional
              paver cleaning service is designed to restore the natural beauty
              of your pavers, removing dirt, stains, and organic growth while
              preserving the integrity of your outdoor surfaces.
            </p>
            <p style={bodyStyle} data-id="element-1548">
              Paver surfaces require specialized care to maintain their
              appearance and longevity. Whether your pavers are made from
              concrete, brick, or natural stone, we have the right tools and
              techniques to clean them effectively without causing damage. Our
              service ensures that your pavers are not only clean but also
              protected against future dirt buildup and weed growth.
            </p>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABar data-id="element-1549" />

        {/* Section — Comprehensive Solutions */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1550">
          <div className="max-w-7xl mx-auto" data-id="element-1551">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1552">
              Comprehensive Paver Cleaning Solutions
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1553">
              Here's what our professional paver cleaning service includes:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1554">
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1555">
                <div className="flex items-center gap-4 mb-4" data-id="element-1556">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1557">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1558">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1559">
                    High-Pressure Washing
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1560">
                  Over time, dirt, dust, and grime can settle into the crevices
                  of your pavers, making them look dull and worn. We use
                  powerful yet controlled pressure washing to deeply clean the
                  surface of the pavers and the joints between them, removing
                  built-up dirt and restoring the original color and vibrancy of
                  your pavers. Our team carefully adjusts the pressure to suit
                  the type of paver material, ensuring a thorough clean without
                  causing damage.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1561">
                <div className="flex items-center gap-4 mb-4" data-id="element-1562">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1563">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1564">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1565">
                    Stain Removal
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1566">
                  Pavers are prone to various types of stains, such as oil
                  spills, rust marks, and tire tracks. These stains can be
                  unsightly and difficult to remove with regular cleaning
                  methods. Our service includes specialized cleaning agents that
                  target tough stains, lifting them from the surface without
                  harming the pavers. We pay special attention to high-traffic
                  areas and spots that have been stained over time to ensure a
                  uniform, clean look.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1567">
                <div className="flex items-center gap-4 mb-4" data-id="element-1568">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1569">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1570">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1571">
                    Weed and Moss Removal
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1572">
                  Weeds, moss, and algae can grow between paver joints, creating
                  an unkempt appearance and potentially damaging the structural
                  integrity of your paver installation. As part of our paver
                  cleaning service, we remove all organic growth from the joints
                  and treat the area with environmentally friendly solutions to
                  prevent future weed growth. This not only improves the
                  appearance of your pavers but also helps prevent shifting or
                  loosening of the individual stones.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1573">
                <div className="flex items-center gap-4 mb-4" data-id="element-1574">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1575">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1576">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1577">
                    Joint Sanding
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1578">
                  After cleaning, paver joints may lose some of the sand that
                  helps hold them in place. To maintain the stability of your
                  pavers, we offer a joint sanding service. We refill the joints
                  with high-quality polymeric sand, which hardens to form a
                  strong bond between the pavers. This prevents future weed
                  growth and helps keep your pavers level and secure, ensuring
                  long-lasting durability.
                </p>
              </div>

              <div className="p-8 rounded-2xl md:col-span-2 lg:col-span-1" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1579">
                <div className="flex items-center gap-4 mb-4" data-id="element-1580">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1581">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1582">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1583">
                    Paver Sealing (Optional)
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1584">
                  Once your pavers are thoroughly cleaned, we recommend applying
                  a high-quality sealant to protect them from future staining,
                  weathering, and dirt buildup. Paver sealing not only enhances
                  the color and appearance of the pavers but also creates a
                  protective barrier that repels water, oil, and other
                  contaminants. This optional service extends the life of your
                  pavers, keeps them looking cleaner for longer, and makes
                  future maintenance easier.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1585">
          <div className="max-w-7xl mx-auto" data-id="element-1586">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1587">
              Why Choose Our Paver Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1588">
              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1589">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1590">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-1591" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1592">
                  Experienced Professionals
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1593">
                  Our trained technicians have the expertise to clean and
                  restore all types of paver materials, ensuring a safe and
                  effective clean every time.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1594">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1595">
                  <WrenchIcon className="h-6 w-6 text-white" data-id="element-1596" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1597">
                  Advanced Equipment
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1598">
                  We use top-of-the-line pressure washing equipment and
                  eco-friendly cleaning solutions to deliver superior results
                  without harming your pavers or the environment.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1599">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1600">
                  <SearchIcon className="h-6 w-6 text-white" data-id="element-1601" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1602">
                  Attention to Detail
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1603">
                  We don't just clean the surface; we pay attention to the
                  joints, stains, and areas where weeds and moss are likely to
                  grow. This comprehensive approach ensures that your pavers
                  look fresh and well-maintained.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1604">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1605">
                  <SparklesIcon className="h-6 w-6 text-white" data-id="element-1606" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1607">
                  Customizable Service
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1608">
                  We tailor our paver cleaning services to your specific needs.
                  Whether you need a one-time deep clean or regular maintenance,
                  we've got you covered.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1609">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1610">
                  <DollarSignIcon className="h-6 w-6 text-white" data-id="element-1611" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1612">
                  Affordable Pricing
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1613">
                  We offer competitive pricing and free estimates, providing
                  high-quality service at a price you can afford.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1614">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1615">
                  <ThumbsUpIcon className="h-6 w-6 text-white" data-id="element-1616" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1617">
                  Satisfaction Guaranteed
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1618">
                  We're committed to making sure our customers are completely
                  satisfied with the results of our paver cleaning services. If
                  you're not happy, we'll work to make it right.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButtonOnBlue data-id="element-1619" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1620">
          <div className="max-w-7xl mx-auto" data-id="element-1621">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1622">
              Benefits of Professional Paver Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-1623">
              <div className="flex gap-5" data-id="element-1624">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1625">
                  <HomeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1626" />
                </div>
                <div data-id="element-1627">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1628">
                    Enhances Curb Appeal
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1629">
                    Clean pavers can dramatically improve the overall appearance
                    of your property. Whether it's a driveway, patio, or
                    walkway, properly maintained pavers make your outdoor spaces
                    look fresh and inviting.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1630">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1631">
                  <ClockIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1632" />
                </div>
                <div data-id="element-1633">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1634">
                    Prolongs Paver Lifespan
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1635">
                    Regular cleaning and maintenance prevent dirt, mold, and
                    weeds from causing long-term damage to your pavers. By
                    removing harmful debris, we help extend the life of your
                    pavers, saving you money on repairs or replacements.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1636">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1637">
                  <TrendingUpIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1638" />
                </div>
                <div data-id="element-1639">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1640">
                    Increases Property Value
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1641">
                    Well-maintained pavers add value to your home or business.
                    Clean, beautiful outdoor spaces can make a strong impression
                    on potential buyers or visitors.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1642">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1643">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1644" />
                </div>
                <div data-id="element-1645">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1646">
                    Improves Safety
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1647">
                    Mold, mildew, and algae can make pavers slippery, especially
                    when wet. Our cleaning service removes these hazards, making
                    your pavers safer to walk on.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1648">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1649">
                  <LeafIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1650" />
                </div>
                <div data-id="element-1651">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1652">
                    Prevents Weed Growth
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1653">
                    By thoroughly cleaning and re-sanding paver joints, we help
                    prevent weeds from growing between the pavers, keeping your
                    outdoor spaces neat and weed-free.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1654">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1655">
                  <SparklesIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1656" />
                </div>
                <div data-id="element-1657">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1658">
                    Reduces Maintenance
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1659">
                    Once your pavers are cleaned and sealed, they require less
                    frequent maintenance, making it easier for you to keep your
                    outdoor areas looking their best.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-1660" />

        {/* Section — Paver Surfaces We Clean */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1661">
          <div className="max-w-7xl mx-auto" data-id="element-1662">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1663">
              Paver Surfaces We Clean
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1664">
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1665">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1666">
                  Patios
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1667">
                  Whether your patio is used for entertaining or relaxation, we
                  can make it look like new by removing dirt, stains, and weeds
                  from the paver surface.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1668">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1669">
                  Driveways
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1670">
                  Paver driveways are a stylish and durable option, but they can
                  accumulate tire marks, oil stains, and dirt. Our driveway
                  cleaning service ensures that your paver driveway remains
                  clean, safe, and attractive.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1671">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1672">
                  Walkways and Paths
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1673">
                  Clean walkways improve the look of your garden or outdoor
                  space while making it safer to navigate. We'll remove any
                  buildup from your paver walkways, ensuring they look sharp and
                  function properly.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1674">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1675">
                  Pool Decks
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1676">
                  Paver pool decks can become slippery with algae and mildew.
                  Our cleaning service removes these hazards, leaving your pool
                  area clean, safe, and enjoyable.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Regular Maintenance */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1677">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1678">
            <h2 className="font-bold mb-6" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1679">
              Regular Paver Maintenance
            </h2>
            <p className="mb-6" style={bodyStyle} data-id="element-1680">
              Routine paver cleaning is essential to maintaining the beauty and
              longevity of your outdoor spaces. We recommend scheduling regular
              cleanings to prevent dirt buildup, organic growth, and weed
              infestations. By keeping your pavers clean and well-maintained,
              you can enjoy their beauty and functionality for years to come.
            </p>
            <p style={bodyStyle} data-id="element-1681">
              Whether your pavers need a deep cleaning or regular maintenance,
              we're here to help. Let our professional team restore the beauty
              and functionality of your outdoor spaces with our expert paver
              cleaning services.
            </p>
          </div>
        </section>

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1682">
          <div className="max-w-7xl mx-auto" data-id="element-1683">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-1684">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1685">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3 border" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)',
              borderColor: '#E8F4FD'
            }} data-id="element-1686">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1687">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-1688" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-1689">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1690">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-1691" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready to Bring Your Pavers Back to Life?" data-id="element-1692" />
      </main>
      <Footer data-id="element-1693" />
    </div>;
}